<template>
  <div>
    <v-layout row wrap class="section">
      <v-flex xs12 class="name">{{ $t("titles.documents") }}</v-flex>

      <v-flex
        xs12
        v-if="Object.keys(documents).length == 0"
        class="alert-info"
        >{{ `documents.empty` | i18n }}</v-flex
      >

      <v-flex xs12 class="documents" v-else>
        <div class="item" v-for="(item, index) in documents">
          <div class="document-title">{{ $t("titles." + item.name) }}</div>
          <div class="preview" @click="downloadDocument(item.url)">
            {{ $t("preview") }}
          </div>
          <v-img
            class="status-icon"
            v-if="item.status == 1"
            :src="'/img/clock.svg'"
          ></v-img>
          <v-img
            class="status-icon"
            v-if="item.status == 2"
            :src="'/img/success.svg'"
          ></v-img>
          <v-img
            class="status-icon"
            v-if="item.status == 3"
            :src="'/img/error.svg'"
          ></v-img>
          <v-select
            :items="Object.values(statusOptions)"
            v-model="item.status"
            item-text="name"
            item-value="value"
            @change="changeDocumentStatus(index, item)"
            class="status"
          ></v-select>
          <v-select
            v-if="item.status == 3"
            :items="Object.values(rejectDocumentOptions)"
            v-model="item.rejected"
            item-text="name"
            item-value="value"
            @change="changeRejectDocument(index, item)"
            class="rejected"
          ></v-select>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: { id: String, event: String },
  data() {
    return {
      documents: []
    };
  },
  computed: {
    statusOptions() {
      var options = this.$store.getters["persons/getStatusDocuments"]();
      var aReturn = [];
      options.forEach(option => {
        aReturn.push({ value: option.id, name: option.name });
      });

      return aReturn;
    },
    rejectDocumentOptions() {
      var options = Object.values(this.$store.getters["getRejectDocuments"]());
      var aReturn = [];
      options.forEach(option => {
        aReturn.push({ value: option.id, name: i18n.t(option.name) });
      });

      return aReturn;
    }
  },
  methods: {
    loadDataPage() {
      var self = this;

      var page = this.$store.getters["navigation/getCurrentPage"].parent_id;

      switch (page) {
        case "participants":
          this.$store
            .dispatch("persons/loadParticipantDocuments", {
              id: this.id,
              event_id: this.$store.getters["events/getCurrentEvent"]().id
            })
            .then(function(response) {
              self.documents = response;
            });
          return;

        case "volunteers":
          this.$store
            .dispatch("volunteers/loadVolunteerDocuments", {
              id: this.id,
              event: this.event
            })
            .then(function(response) {
              self.documents = response;
            });
      }
    },

    downloadDocument(url) {
      if (url != null) {
        window.open(url + "?" + Math.floor(Math.random() * 1000000));
      } else {
        this.$popup.alert({
          message: i18n.t("document.not_upload"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    changeDocumentStatus(index, item) {
      var self = this;

      var page = this.$store.getters["navigation/getCurrentPage"].parent_id;
      switch (page) {
        case "participants":
          this.$store
            .dispatch("persons/changeParticipantDocumentStatus", {
              id: this.id,
              event: this.event,
              key: index,
              status: item.status,
              url: item.url
            })
            .then(response => {
              if (item.status == 3) {
                self.$popup.rejectDocument(
                  {
                    message: i18n.t("documents.reject.message"),
                    title: i18n.t("documents.reject.title"),
                    btnSuccess: i18n.t("confirm"),
                    reject_document: self.$store.getters.getRejectDocuments()
                  },
                  function(plug, params, store) {
                    // console.log(plug, params);
                    self.$overlay.loading();
                    self.$store
                      .dispatch("persons/rejectParticipantDocument", {
                        id: self.id,
                        event: self.event,
                        key: index,
                        reject: plug.reject_document_id
                      })
                      .then(() => {
                        self.$popup.close();
                        self.$overlay.hide();
                        self.$popup.alert({
                          message: i18n.t("success.email_sended"),
                          btnSuccess: i18n.t("accept")
                        });
                      });
                  }
                );
              }
            });
          break;
        case "volunteers":
          this.$store
            .dispatch("volunteers/changeVolunteerDocumentStatus", {
              id: this.id,
              event: this.event,
              key: index,
              status: item.status,
              url: item.url
            })
            .then(response => {
              if (item.status == 3) {
                self.$popup.rejectDocument(
                  {
                    message: i18n.t("documents.reject.message"),
                    title: i18n.t("documents.reject.title"),
                    btnSuccess: i18n.t("confirm"),
                    reject_document: self.$store.getters.getRejectDocuments()
                  },
                  function(plug, params, store) {
                    // console.log(plug, params);
                    self.$overlay.loading();
                    self.$store
                      .dispatch("volunteers/rejectVolunteerDocument", {
                        id: self.id,
                        event: self.event,
                        key: index,
                        reject: plug.reject_document_id
                      })
                      .then(() => {
                        self.$popup.close();
                        self.$overlay.hide();
                        self.$popup.alert({
                          message: i18n.t("success.email_sended"),
                          btnSuccess: i18n.t("accept")
                        });
                      });
                  }
                );
              }
            });
      }
    },
    changeRejectDocument(index, item) {
      var self = this;
      self.$overlay.loading();
      var page = this.$store.getters["navigation/getCurrentPage"].parent_id;
      switch (page) {
        case "participants":
          this.$store
            .dispatch("persons/rejectParticipantDocument", {
              id: this.id,
              event: this.event,
              key: index,
              reject: item.rejected
            })
            .then(response => {
              self.$overlay.hide();
              self.$popup.alert({
                message: i18n.t("success.email_sended"),
                btnSuccess: i18n.t("accept")
              });
            });
          break;
        case "volunteers":
          this.$store
            .dispatch("volunteers/rejectVolunteerDocument", {
              id: this.id,
              event: this.event,
              key: index,
              reject: item.rejected
            })
            .then(response => {
              self.$overlay.hide();
              self.$popup.alert({
                message: i18n.t("success.email_sended"),
                btnSuccess: i18n.t("accept")
              });
            });
      }
    }
  },
  created() {
    this.loadDataPage();
  },
  watch: {
    $route: "loadDataPage"
  }
};
</script>

<style lang="scss">
.v-picker__actions .v-btn__content {
  color: #000;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss" scoped>
.section {
  .name {
    font-weight: lighter;
    font-size: 24px;
    @include font-size(14px);
    border-bottom: 1px solid #ddd;
    margin: 10px 0 20px 0;
    color: $main-color;
    text-transform: uppercase;
    margin-bottom: 20px;
    padding-bottom: 5px;
    border-bottom: 2px solid $complem-color-dark;
    color: $complem-color-dark;
    position: relative;
  }
}
.alert {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.alert-info {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.documents {
  .item {
    width: 100%;
    margin-bottom: 10px;

    .document-title {
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .preview {
      background-color: #ddd;
      display: inline-block;
      padding: 10px;
      margin-right: 50px;
      cursor: pointer;
      border-radius: 3px;

      &:hover {
        background-color: #bbb;
      }
    }

    .status-icon {
      width: 25px;
      height: 100%;
      display: inline-block;
      padding: 0px;
      position: relative;
      top: 10px;
      margin-right: 10px;
    }

    .status {
      display: inline-block;
      width: 250px;
      margin: 0 10px;
    }
    .rejected {
      display: inline-block;
      width: 250px;
    }
  }
}
</style>
